import React from "react";
import styles from "./EachLearningCard.module.css";
import BlueBtn from "../../../../Components/BlueBtn/BlueBtn.module";
import CtaBtns from "../../../../Components/CtaBtns/CtaBtns.module";
const EachLearningCard = ({ title, img, description, onPlay }) => {
  return (
    <div class={styles.eachLearningCard}>
      <div className={styles.learnings}>آموزش مرحله به مرحله</div>
      <div className={styles.title}>{title}</div>
      <img className={styles.image1} src={img} />

      <div className={styles.descs}>{description}</div>
      <CtaBtns onAtion={onPlay} noBorder={true}>
        مشاهده ویدیو
      </CtaBtns>
    </div>
  );
};

export default EachLearningCard;
